import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import ImageDialogTrigger from './ImageDialogTrigger';

function GallerySlider({ images }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = useCallback(() => {
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }, [images.length]);

  const handleNext = useCallback(() => {
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, [images.length]);

  const activeImage = images[activeIndex];

  return (
    <div className="gallery-slider">
      <div className="gallery-slider-main">
        <button
          type="button"
          className="gallery-slider-nav gallery-slider-prev"
          onClick={handlePrev}
          aria-label="Imagem anterior"
        >
          &#8249;
        </button>
        <ImageDialogTrigger
          src={activeImage.src}
          alt={activeImage.alt}
          triggerClassName="gallery-slider-trigger"
          imageClassName="gallery-slider-main-img"
        />
        <button
          type="button"
          className="gallery-slider-nav gallery-slider-next"
          onClick={handleNext}
          aria-label="Próxima imagem"
        >
          &#8250;
        </button>
        <span className="gallery-slider-counter">
          {activeIndex + 1} / {images.length}
        </span>
      </div>
      <div className="gallery-slider-thumbs">
        {images.map((img, index) => (
          <button
            type="button"
            key={img.src}
            className={`gallery-slider-thumb${index === activeIndex ? ' active' : ''}`}
            onClick={() => setActiveIndex(index)}
            aria-label={`Ver foto ${index + 1}: ${img.alt}`}
          >
            <img src={img.src} alt={img.alt} />
          </button>
        ))}
      </div>
    </div>
  );
}

GallerySlider.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired
    })
  ).isRequired
};

export default GallerySlider;
